import React, {Component} from 'react';
import styles from './IconBox.less';

export default class IconBox extends Component {
	render() {
		const {icon, children, className, ...props} = this.props;
		const {
			'icon-box': iconBoxClass,
			'icon-box__col': colClass,
			'icon-box__col_label': colLabelClass
		} = styles;

		return (
			<span className={[className, iconBoxClass].join(' ')} {...props}>
				<span className={colClass}>{icon}</span>
				{children && <span className={[colClass, colLabelClass].join(' ')}>{children}</span>}
			</span>
		);
	}
}